import React from "react";

const Userfooter = () => {
  return (
    <footer className="mt-16 text-center py-10 border-t border-gray-100 text-[10px] font-black text-gray-400 uppercase tracking-[0.2em]">
      <p>© Copyright 2026 Zilla Parishad Sangli. Design & Developed by Zilla Parishad.</p>
    </footer>
  );
};

export default Userfooter;
